"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupAvatarIcon = exports.contactPickerTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireDefault(require("react"));
const {
  buttonDestructive,
  dangerDark30,
  dangerLight30,
  neutralDark20
} = _designTokens.lodestarColors;
const {
  red800,
  red75,
  red600,
  neutral400
} = _designTokens.ursaColors;
const contactPickerTheme = (0, _sdsThemeInternal.themed)({
  selectedOption: {
    fontSize: {
      "lodestar-light": "13px",
      "ursa-light": "14px"
    }
  },
  option: {
    // This is used for virtualization.
    overallHeight: {
      "lodestar-light": 56,
      "ursa-light": 48
    },
    avatar: {
      size: {
        "lodestar-light": "small",
        "ursa-light": "medium"
      },
      paddingRight: {
        "lodestar-light": "12px",
        "ursa-light": "6px"
      }
    },
    name: {
      fontSize: {
        "lodestar-light": "13px",
        "ursa-light": "14px"
      },
      height: {
        "lodestar-light": "18px",
        // We need to cut a px off here to get the right height of 48px overall.
        "ursa-light": "17px"
      }
    },
    detailItem: {
      fontSize: {
        "lodestar-light": "13px",
        "ursa-light": "12px"
      },
      height: {
        "lodestar-light": "18px",
        "ursa-light": "13px"
      }
    },
    padding: {
      "lodestar-light": "4px 12px",
      "ursa-light": "8px"
    },
    invalid: {
      text: {
        "lodestar-light": `var(--smar--sds--contact--picker--chip--invalid--text--color, ${(0, _designTokensReact.color)("color--background--destructive--strongest", dangerDark30)})`,
        "ursa-light": `var(--smar--sds--contact--picker--chip--invalid--text--color, ${(0, _designTokensReact.color)("color--text--error--default", red800)})`
      },
      background: {
        "lodestar-light": `var(--smar--sds--contact--picker--chip--invalid--background--color, ${(0, _designTokensReact.color)("color--background--destructive--weakest", dangerLight30)})`,
        "ursa-light": `var(--smar--sds--contact--picker--chip--invalid--background--color, ${(0, _designTokensReact.color)("color--background--error--weak", red75)})`
      },
      icon: {
        "lodestar-light": `var(--smar--sds--contact--picker--chip--invalid--icon--color, ${buttonDestructive})`,
        //no token available
        "ursa-light": `var(--smar--sds--contact--picker--chip--invalid--icon--color, ${(0, _designTokensReact.color)("color--icons--error--default", red600)})`
      }
    },
    disabled: {
      "lodestar-light": `var(--smar--sds--contact--picker--option--disabled--text--color, ${(0, _designTokensReact.color)("color--text--neutral--weak", neutralDark20)})`,
      "ursa-light": `var(--smar--sds--contact--picker--option--disabled--text--color, ${(0, _designTokensReact.color)("color--text--neutral--weaker", neutral400)})`
    }
  },
  checkmark: {
    position: {
      single: "after",
      multi: {
        "lodestar-light": "after",
        "ursa-light": "before"
      }
    },
    style: {
      single: "simple",
      multi: {
        "lodestar-light": "simple",
        "ursa-light": "checkbox"
      }
    }
  }
});
exports.contactPickerTheme = contactPickerTheme;
const groupAvatarIcon = {
  "lodestar-light": /*#__PURE__*/_react.default.createElement(_lodestarIcons.ShareIcon, {
    size: "medium"
  }),
  oldestar: /*#__PURE__*/_react.default.createElement(_lodestarIcons.ShareIcon, {
    size: "medium"
  }),
  "ursa-light": /*#__PURE__*/_react.default.createElement(_ursaIcons.CollaborateIcon, {
    size: 24
  })
};
exports.groupAvatarIcon = groupAvatarIcon;
//# sourceMappingURL=contactPickerTheme.js.map